export const LIANG_HUANG_EVENT = {
  year: 2026,
  title: {
    Chinese: "2026 梁皇寶懺精進共修",
    English: "2026 Liang Huang Jeweled Repentance Sunday Service",
  },
  dateRange: {
    Chinese: "2026年9月6日至10月18日",
    English: "September 6 - October 18, 2026",
  },
  description: {
    Chinese: "寶林禪寺將於2026年9月6日至10月18日期間，每週日禮拜梁皇寶懺，歡迎大眾報名，一同精進用功，回向法界有情，共證菩提。",
    English: "Join us every Sunday at Bao Lin Chan Monastery for the Liang Huang Jeweled Repentance practice. Cultivate diligently, dedicate the merits to all sentient beings, and attain enlightenment together.",
  },
};

export const LIANG_HUANG_SESSIONS = [
  { field: "s6_9_09_30", checkinField: "checkin_6_9_09_30", scroll: 1, dateKey: "2026-09-06", date: { Chinese: "9月6日", English: "September 6" }, time: "09:30 - 13:00", allDay: true },
  { field: "s6_9_13_30", checkinField: "checkin_6_9_13_30", scroll: 2, dateKey: "2026-09-06", date: { Chinese: "9月6日", English: "September 6" }, time: "13:30 - 17:30", allDay: true },
  { field: "s13_9_09_30", checkinField: "checkin_13_9_09_30", scroll: 3, dateKey: "2026-09-13", date: { Chinese: "9月13日", English: "September 13" }, time: "09:30 - 13:30" },
  { field: "s20_9_09_30", checkinField: "checkin_20_9_09_30", scroll: 4, dateKey: "2026-09-20", date: { Chinese: "9月20日", English: "September 20" }, time: "09:30 - 13:30" },
  { field: "s27_9_09_30", checkinField: "checkin_27_9_09_30", scroll: 5, dateKey: "2026-09-27", date: { Chinese: "9月27日", English: "September 27" }, time: "09:30 - 13:00", allDay: true },
  { field: "s27_9_13_30", checkinField: "checkin_27_9_13_30", scroll: 6, dateKey: "2026-09-27", date: { Chinese: "9月27日", English: "September 27" }, time: "13:30 - 17:30", allDay: true },
  { field: "s4_10_09_30", checkinField: "checkin_4_10_09_30", scroll: 7, dateKey: "2026-10-04", date: { Chinese: "10月4日", English: "October 4" }, time: "09:30 - 13:30" },
  { field: "s11_10_09_30", checkinField: "checkin_11_10_09_30", scroll: 8, dateKey: "2026-10-11", date: { Chinese: "10月11日", English: "October 11" }, time: "09:30 - 13:30" },
  { field: "s18_10_09_30", checkinField: "checkin_18_10_09_30", scroll: 9, dateKey: "2026-10-18", date: { Chinese: "10月18日", English: "October 18" }, time: "09:30 - 13:00", allDay: true, completion: true },
  { field: "s18_10_13_30", checkinField: "checkin_18_10_13_30", scroll: 10, dateKey: "2026-10-18", date: { Chinese: "10月18日", English: "October 18" }, time: "13:30 - 17:30", allDay: true, completion: true },
];

export const getSessionLabel = (session, language) => {
  const scroll = language === "English" ? `Scroll ${session.scroll}` : `卷${["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"][session.scroll - 1]}`;
  return `${scroll}: ${session.date[language]} ${session.time}`;
};

export const groupLiangHuangSessions = () => LIANG_HUANG_SESSIONS.reduce((groups, session) => {
  const current = groups.find((group) => group.dateKey === session.dateKey);
  if (current) {
    current.sessions.push(session);
  } else {
    groups.push({ dateKey: session.dateKey, sessions: [session] });
  }
  return groups;
}, []);
